import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { mapSaverShip } from '../tiles/mapSaverShip-sidecar'
import { IButton } from '../uiParts/buttons'
import { buttons } from '../uiParts/buttons-sidecar'

import { uiBuild } from './uiBuild-sidecar'
import { uiNewGame } from './uiNewGame-sidecar'
import { uiSpeedBar } from './uiSpeedBar-sidecar'
import { uiStats } from './uiStats-sidecar'
import { TileSelectorMode } from './uiTileSelector'
import { uiTravel } from './uiTravel-sidecar'
import { uiDebug } from './uiDebug-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'

interface IModeButton {
  button: IButton
  mode: TileSelectorMode
}

interface IData {
  isOpen: boolean
  isSemiOpen: boolean
  modeButtons: IModeButton[]
  buttons: IButton[]
  // textMode: IStevieText
}
let _data: IData | null = null

export const getData = () => {
  if (!_data) {
    let ctx = scene.getContext()
    // let text = stevieText.create(ctx.font24, 0, 0)
    // stevieText.setText(text, 'GAME MoDE!')
    let btns = []
    let modeButtons: IModeButton[] = []
    let bw = 100
    let x = 0
    let y = 0

    let button = buttons.create(layers.getLayers().ui, x, y, 'T', () => {
      // tileMapEditor.setMode('test')
      setOpen(true, !_data?.isSemiOpen)
    })
    x += bw / 2
    btns.push(button)

    const addModeButton = (
      text: string,
      mode: TileSelectorMode,
      action: (isActive: boolean) => boolean | void = () => {},
    ) => {
      button = buttons.create(layers.getLayers().ui, x, y, text, () => {
        clickEater.tempEat()
        if (tileMapEditor.getMode() === mode) {
          if (action(false) !== false) {
            tileMapEditor.setMode('test')
          }
        } else {
          tileMapEditor.setMode(mode)
          action(true)
        }
      })
      x += bw
      btns.push(button)
      modeButtons.push({
        button,
        mode,
      })
    }

    addModeButton('Test', 'test')
    addModeButton('Draft', 'draft')
    addModeButton('Decon', 'deconstruct-hull')
    addModeButton('Build', 'build', (isActive) => {
      uiBuild.toggle()
      return false
    })
    addModeButton('Mine', 'mine')
    addModeButton('Stats', 'stats')
    addModeButton('O2', 'o2')
    x += 50
    addModeButton('Travel', 'travel')
    x += 50
    addModeButton('New', 'new-game')
    addModeButton('Debug', 'debug-spawn', (isActive) => {
      uiDebug.toggle()
      return false
    })

    // btns.push(button)
    // button = buttons.create(layers.getLayers().ui, x, 22, 'Build', () => {
    //   tileMapEditor.setMode('build')
    //   uiBuild.toggle()
    // })

    button = buttons.create(layers.getLayers().ui, x, y, 'Save', () => {
      mapSaverShip.saveLater()
    })
    btns.push(button)
    x += bw

    _data = {
      isOpen: true,
      isSemiOpen: false,
      buttons: btns,
      // textMode: text,
      modeButtons,
    }
    setOpen(false)
  }
  return _data
}

export const closeDialogs = () => {
  uiBuild.setOpen(false)
  uiDebug.setOpen(false)
  uiStats.setOpen(false)
  uiTravel.setOpen(false)
  uiNewGame.setOpen(false)
}

export const setOpen = (isOpen: boolean, isSemiOpen: boolean = false) => {
  let data = getData()
  data.isOpen = isOpen
  data.isSemiOpen = isSemiOpen

  uiSpeedBar.setOpen(isOpen && !isSemiOpen)

  l.forEach(data.buttons, (c, cIdx) => {
    if (isSemiOpen) {
      buttons.setVisible(c, cIdx === 0)
    } else {
      buttons.setVisible(c, isOpen)
    }
  })
  // stevieText.setVisible(data.textMode, isOpen && !isSemiOpen)
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()

  let data = getData()
  if (data.isOpen) {
    // let mode = tileMapEditor.getMode()
    // stevieText.setText(data.textMode, mode)

    l.forEach(data.modeButtons, (c) => {
      buttons.setSelected(c.button, c.mode === tileMapEditor.getMode())
    })
  }
}
